import * as util from "lib/util.js";
import { Router } from "@vaadin/router/dist/vaadin-router.js";
import { until } from "lit-html/directives/until.js";
import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import PubSub from "pubsub-js";
import "./kb-dialog-cart.js";
import "./kb-nav.js";
import "./kb-header.js";
import "./kb-header-temp.js";
import "./kb-pubsearch";
import "./kb-consent-footer.js";
import "./kb-dialog-error.js";
import "./kb-dialog-notfound.js";
import "./kb-dialog-topic.js";
import "./kb-toast.js";
import "./kb-not-found.js";
import { getAvailableLanguages } from "../lib/util.js";

class KbApp extends LitElement {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.storeHomepageMetadata();
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.loggedin = false;
    this.state = storeInstance.state;
    this.kbUser = this.state.kb_user;
    this._init();
    this.getAuthInfoPromise = this.getAuthInfo();
    storeInstance.dispatch("setLanguage", this.getPathLang());
    storeInstance.dispatch(
      "setStrings",
      this.state[this.state.langCode]
        ? this.state[this.state.langCode]
        : this.state[this.state.default_lang_code]
    );
    window.addEventListener("resize", this.updateScreenSpecs.bind(this));
    this.getHelpsetId();
    this.updateScreenSpecs();
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  postLoginActions() {
    this.initRouter();
    this.initDialogs();
    storeInstance.dispatch("getConfiguredLangs");
    storeInstance.dispatch("getPanelControls");
    storeInstance.dispatch("getMimeTypes");
    this._loadConfig("company_config.json");
    this._loadConfig("user_config.json");
  }

  async getAuthInfo() {
    PubSub.publish("requestout", null);
    try {
      const response = await fetch("/kb/jrest/getAuthInfo");
      if (!response.ok) {
        this.redirectToSSOLogin();
        throw Error();
      }
      response.json().then((userData) => {
        if (userData.userName === undefined || userData.userName == "") {
          this.redirectToSSOLogin();
        } else {
          storeInstance.dispatch("legacyHandleAuthData", userData);
          this.postLoginActions();
        }
        return userData;
      });
    } catch (e) {
      console.log(e);
      throw e;
    } finally {
      PubSub.publish("requestin", null);
    }
  }

  redirectToSSOLogin() {
    let pathname = window.location.pathname;
    let searchString = window.location.search || "";
    var compRedir = encodeURIComponent("?redir=" + pathname + searchString);
    //var compRedir = encodeURIComponent("?redir=" + window.location);
    var redir = encodeURI("/kb/jrest/loginReaderIDP" + compRedir);
    window.location =
      "/lwa/jrest/Auth/IDPLogin?appId=kb&idpclient=choose&redirecturi=" + redir;
  }

  _loadConfig(configFile) {
    fetch("/kb/config/" + configFile)
      .then(
        function (response) {
          if (!response.ok) {
            throw Error(); //to bail out of promise chain
          }
          return response;
        }.bind(this)
      )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        Object.keys(data).forEach(function (key) {
          storeInstance.dispatch("setState", {
            property: key,
            value: data[key],
          });
        });
      })
      .catch(function (error) {})
      .finally(function () {});
  }

  storeHomepageMetadata() {
    window.homeDescription = document.querySelector(
      "head meta[name='description']"
    )?.content;
    window.homeTitle = document.querySelector("head title")?.innerText;

    homeTitle = homeTitle ? homeTitle : "Kb Reader | home";
    homeDescription = homeDescription
      ? homeDescription
      : "Technical Documentation.";
  }

  _init() {}

  resetDefaults() {
    // storeInstance.dispatch("setState", {property: "browse_lang_filter" , value: this.state.default_lang_object} )
  }

  getHelpsetId() {
    let queryParams = new URLSearchParams(window.location.search);
    let helpsetId;
    if (queryParams.has("helpsetId")) {
      helpsetId = queryParams.get("helpsetId");
    } else {
      helpsetId = "";
    }
    storeInstance.dispatch("setState", {
      property: "filter_helpset_id",
      value: helpsetId,
    });
  }

  updateScreenSpecs() {
    storeInstance.dispatch("setViewportDimensions");
    setTimeout(
      function () {
        storeInstance.dispatch("touch");
      }.bind(this),
      200
    );
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    this.kbUser = this.state.kb_user;
    // if (this.string) {
    //   this.myRender();
    //   if (this.state.kb_user) {
    //     if (!this.loggedin) {
    //       this.loggedin = true;
    //       if (
    //         this.state.last_username &&
    //         this.state.last_username != this.state.kb_user.username
    //       ) {
    //         location = location.origin + "/kb/" + this.state.langCode;
    //       }
    //     }
    //     if (!this.router) {
    //       if (!this.getLangsCalled) {
    //         this.getLangsCalled = true;
    //         storeInstance.dispatch("getConfiguredLangs");
    //       }
    //       if (this.state.global_langs && !this.state.default_lang_object) {
    //         var defLangObj = this.state.global_langs.filter(
    //           function (item) {
    //             return item.langCode === this.state.default_lang_code;
    //           }.bind(this)
    //         );
    //         if (defLangObj[0]) {
    //           storeInstance.dispatch("setState", {
    //             property: "default_lang_object",
    //             value: defLangObj[0],
    //           });
    //         }
    //       }

    //       if (this.state.strings) {
    //         if (!this.defaultInit) {
    //           this.defaultInit = true;
    //           //this.initDefaults();
    //         }
    //         if (!this.dialogsCreated) {
    //           this.initDialogs();
    //         }
    //         if (this.dialogsCreated && !this.router) {
    //           this.initRouter();
    //           if (this.onRouterInit) {
    //             Router.go(this.onRouterInit);
    //             this.onRouterInit = null;
    //           }
    //         }
    //       }
    //     } else {
    //       if (this.router.location) {
    //         this.appHeader = this.shadowRoot.querySelector("#appheader");
    //         this.appHeader.location = this.router.location;
    //       }
    //     }
    //   } else {
    //     if (!this.auth_method_requested) {
    //       this.auth_method_requested = true;
    //       // storeInstance.dispatch("getAuthInfo");
    //     }
    //     this.loggedin = false;
    //   }
    // }
  }

  // myRender() {
  //   render(this.appTemplate(), this.shadowRoot);
  //   if (!this.toast) {
  //     this.toast = this.shadowRoot.querySelector("#toast");
  //   }
  // }

  // Validates that there is a language table for url parameter other wise redirect to english
  async validateLangcode(context, commands) {
    const langCode = context.params.langCode;
    const availableLanguages = await getAvailableLanguages();
    if (availableLanguages.includes(langCode)) {
      return true;
    } else {
      PubSub.publish("notifyUser", {
        messageType: "Negative",
        message: "Invalid language. Redirecting to English...",
        duration: 5,
      });
      setTimeout(() => (window.location.href = "/kb/en-US"), 3000);
    }
  }

  getPathLang() {
    var langCode = this.state.default_lang_code;
    if (window.location.pathname.toLowerCase() == "/kb/") {
      window.location.href = "/kb/" + langCode;
    } else {
      var path = window.location.pathname.split("/");
      if (path.length >= 2) {
        langCode = window.location.pathname.split("/")[2];
      }
    }
    return langCode;
  }

  local(inVal) {
    return localize(inVal, this.state.langCode);
  }

  initDialogs() {
    this.dialogsContainer = this.shadowRoot.querySelector("#dialogs");
    if (this.dialogsContainer) {
      this.dialogsContainer.appendChild(
        document.createElement("kb-dialog-cart")
      );
      this.dialogsContainer.appendChild(
        document.createElement("kb-dialog-error")
      );
      this.dialogsContainer.appendChild(
        document.createElement("kb-dialog-notfound")
      );
      this.dialogsContainer.appendChild(
        document.createElement("kb-dialog-topic")
      );
      this.dialogsCreated = true;
    }
  }

  initRouter() {
    if (!this.router) {
      const outlet = this.shadowRoot.querySelector("DIV");
      this.router = new Router(outlet);
      this.router.setRoutes([
        {
          path: "/kb/:langCode",
          action: async (context, command) =>
            this.validateLangcode(context, command),
          children: [
            { path: "/", component: "kb-nav" },
            { path: "/home", component: "kb-nav" },
            { path: "/:externalId", component: "kb-nav" },
            { path: "/:externalId/:kbrid", component: "kb-nav" },
            { path: "/(.*)", component: "kb-not-found" },
          ],
        },
        { path: "(.*)", component: "kb-not-found" },
      ]);
    }
  }

  submitForm(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      var submitBtn = this.shadowRoot.getElementById("closeDialogButton");
      submitBtn.click();
    }
  }

  appTemplate() {
    return html` <style>
        #outlet {
          display: block;
          background-color: var(--background-color);
          font-family: var(--kb-font-family-sans);
          font-size: var(--kb-body-font-size);
        }
      </style>
      <!-- <kb-header id="appheader"></kb-header> -->
      <kb-header-temp id="appheader"></kb-header-temp>
      <div id="outlet"></div>
      <kb-dialog-login></kb-dialog-login>
      <span id="dialogs"></span>
      <kb-toast></kb-toast>
      <custom-footer></custom-footer>
      <kb-consent-footer></kb-consent-footer>`;
  }

  testTemplate() {
    return html`Loaded`;
  }

  loadingTemplate() {
    return html`...`;
  }

  /* Templates */
  render() {
    return html` ${until(
      this.getAuthInfoPromise
        .then(() => this.appTemplate())
        .catch(() => this.loadingTemplate()),
      this.loadingTemplate()
    )}`;
  }

  closeErrorDialog() {
    this.shadowRoot.querySelector("#error-dialog").close();
  }
}

customElements.define("kb-app", KbApp);
